import { render } from "./IndexFlows.vue?vue&type=template&id=49af60fd&ts=true"
import script from "./IndexFlows.vue?vue&type=script&lang=ts"
export * from "./IndexFlows.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__